import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { BtnTheme } from '../../type/btnTheme.type';
import { FontWeight } from '../../type/fontWeight.type';
import { BtnType } from '../../type/btnType.type';
import { BtnIconPosition } from '../../type/btnIconPosition.type';

@Component({
  selector: 'app-stroked-btn-with-icon',
  templateUrl: './stroked-btn-with-icon.component.html',
  styleUrls: ['./stroked-btn-with-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StrokedBtnWithIconComponent {
  @Input('color') color: ThemePalette;
  @Input('text') text: string = 'Placeholder';
  @Input('theme') theme: BtnTheme;
  @Input('uppercase') uppercase: boolean = true;
  @Input('disabled') disabled: boolean = false;
  @Input('fontWeight') fontWeight: FontWeight = 400;
  @Input('type') type: BtnType = 'button';
  @Input('icon') icon: string = 'favorite';
  @Input('iconColor') iconColor: ThemePalette;
  @Input('iconPosition') iconPosition: BtnIconPosition = 'left';
}
